import { registerModule } from '@/app/app.store'
import { STORE } from './shop.service'
import Common from '../common.vue'

export default {
  path: '/',
  component: Common,
  children: [
    {
      beforeEnter: (to: any, from: any, next: () => void) => {
        registerModule('shopHome', STORE)
        next()
      },
      path: 'shop',
      name: 'shop',
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      component: () => import('./shop.vue'),
    },
    {
      beforeEnter: (to: any, from: any, next: () => void) => {
        registerModule('shopHome', STORE, true)
        next()
      },
      path: "shopAlbum",
      name: 'shopAlbum',
      component: () => import('./components/albumModule/index.vue'),
    },
    {
      beforeEnter: (to: any, from: any, next: () => void) => {
        registerModule('shopHome', STORE, true)
        next()
      },
      path: "shopLicence",
      name: 'shopLicence',
      component: () => import('./components/licenceModule/index.vue'),
    }
  ]
}
